<template>
  <main id="charge"><router-view></router-view></main>
</template>
<script>
export default {
  name: "Privacy",
};
</script>
